var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Vaitality-homes-page-Copy",
    transform: "translate(-1156.000000, -3599.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 3455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-icon",
    transform: "translate(1156.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75,13.6044615 C34.7273438,14.0461538 33.6376563,14.3389231 32.5015625,14.4810769 C33.6703125,13.794 34.5623437,12.7143077 34.9817187,11.4129231 C33.8920313,12.0526154 32.6889063,12.5044615 31.4067187,12.7566154 C30.3720313,11.6718462 28.8973438,11 27.2885938,11 C24.1673438,11 21.6545313,13.4944615 21.6545313,16.5524615 C21.6545313,16.9924615 21.6923438,17.4155385 21.7851562,17.8183077 C17.098125,17.5932308 12.9507813,15.3813846 10.1646875,12.012 C9.67828125,12.8429231 9.39296875,13.794 9.39296875,14.8178462 C9.39296875,16.7403077 10.3984375,18.4444615 11.8971875,19.4310769 C10.9914063,19.4141538 10.1028125,19.1552308 9.35,18.7473846 C9.35,18.7643077 9.35,18.7863077 9.35,18.8083077 C9.35,21.5058462 11.3042188,23.7464615 13.866875,24.2626154 C13.4079688,24.3861538 12.9078125,24.4453846 12.38875,24.4453846 C12.0278125,24.4453846 11.6634375,24.4250769 11.3214063,24.3506154 C12.051875,26.5489231 14.1246875,28.1650769 16.589375,28.2175385 C14.67125,29.6949231 12.2357813,30.5850769 9.59921875,30.5850769 C9.136875,30.5850769 8.6934375,30.5647692 8.25,30.5089231 C10.7473438,32.0946154 13.7070313,33 16.89875,33 C27.273125,33 32.945,24.5384615 32.945,17.204 C32.945,16.9586154 32.9364063,16.7216923 32.924375,16.4864615 C34.0432813,15.7046154 34.9834375,14.7281538 35.75,13.6044615 Z",
    id: "Shape",
    fill: "#03A9F4",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.6982638c15d91d97e8623a133231bf9e.svg";
export { ForwardRef as ReactComponent };